import Navbar from './Navbar';
import Home from './Home';
import Footer from './Footer';
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import CV_Resume from './CV_Resume';
import Portfolio from './Portfolio';
import Contact from './Contact';
import Running from './Running';
// import Modal from './Modal';

function App() {
	
	return (
		<Router>
			<div className="App">
				<Navbar/>
				<div className="content">
					<Switch>

						<Route exact path="/">
							<Home/>
						</Route>

						<Route exact path="/cv_resume">
							<CV_Resume/>
						</Route>
						
						<Route exact path="/portfolio">
							<Portfolio/>
						</Route>

						<Route exact path="/contact">
							<Contact/>
						</Route>

						<Route exact path="/running">
							<Running/>
						</Route>

					</Switch>
				</div>
				<Footer/> 
			</div>
		</Router>
	);
}

export default App;
